// removed by extract-text-webpack-plugin
module.exports = {"insetSection":"G545909 G55d311 Ge0b40c","heading":"G896841 Gda84e6 G583c98 G75a8bf","bold":"Gc10a94 G42bbcd","paragraph":"G43b5bf"};